export const fnObj = {
    statusCode: "999",
    data: null,
    msg: ""
}